module.exports = __webpack_public_path__ + "static/media/6.4a13f4c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/6.png
// module id = 715
// module chunks = 0